export default __webpack_public_path__ + "images/SpeakersPhotos/Tiffany_de_la_Torre_Edefense.jpg?4ee7ee3f";